<template>
    <div>
        <iframe frameborder="0" class="preview-pane"></iframe>
    </div>
</template>
<script>
    export default {
        props: {
            filterData: Object
        },
        created() {
            this.filterData = this.$route.query;
            this.loadReportData();
        },
        methods: {
            loadReportData() {
                request({
                    url: "get-report",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    $('.preview-pane').attr('height', window.innerHeight).attr('width', '100%');
                    $('.preview-pane').attr('src', 'data:application/pdf;base64,' + response.data.pdfRaw);
                })
                .catch(error => {
                    console.log(error);
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Layout/AccountBookings/IncomeStatement.vue